import React, { FC } from 'react';
import { CommodityStatusStyled } from './styled';

export const CommodityStatus: FC = (props) => {
  return <CommodityStatusStyled {...props} />;
};
